import { render, staticRenderFns } from "./SelectPerson.vue?vue&type=template&id=47d8479a&"
import script from "./SelectPerson.vue?vue&type=script&lang=js&"
export * from "./SelectPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports